api = new RMAPI()

(($) ->

	$("body").on 'click', ->
		$(".header-site-switcher .switcher-current, .header-site-switcher .switcher-sites").removeClass 'open'
		$('.rm-dropdown-menu.open').removeClass 'open'

	$(".header-site-switcher .switcher-current").on 'click', (e) ->
		e.stopPropagation()
		
		$(@).add($(@).siblings('.switcher-sites')).toggleClass 'open'

	$(".rm-page-message .message-close").on 'click', ->
		$(@).closest('.rm-page-message').animate { opacity: 'hide' }, 300, ->
			$(@).remove()
	
	$(".download-button").on 'click', (e) ->
		e.preventDefault()
		selector = $(@).siblings '.download-options'
		window.open selector.val(), 'new'

	site_messages = $(".wp-block-rm-site-messages")
	$(site_messages).on 'click', '.messages-pagination .pagination-buttons .buttons-item', (e) ->
		e.preventDefault()

		messages = $(".messages-items .items-message")
		current = messages.filter '.show'
		dir = $(@).attr('href').replace '#', ''

		switch dir
			when 'next'
				next = current.next()
				if messages.last().hasClass 'show'
					next = messages.first()
			when 'prev'
				next = current.prev()
				if messages.first().hasClass 'show'
					next = messages.last()
		
		$(".messages-pagination .pagination-current span", site_messages).text (next.index() + 1)
		current.removeClass 'show'
		next.addClass 'show'

	$(site_messages).on 'click', '.messages-close', (e) ->
		e.preventDefault()

		site_messages.slideUp 400
		api.post 'dismiss_site_message', {}, (data) ->
			console.log data
	
	$("*[data-tooltip]").each ->
		el = $(@)
		tooltip = el.attr 'data-tooltip'
		el.append '<span class="rm-tooltip">' + tooltip + '</span>'
	
	# $(".rm-dropdown--click, .rm-dropdown--click .rm-dropdown-opener").on 'click', (e) ->
	
	$(".rm-dropdown--click .rm-dropdown-opener").on 'click', (e) ->
		e.stopPropagation()
		$(@).siblings('.rm-dropdown-menu').toggleClass 'open'

	$(".step-box-check").click ->
		box = $(@).closest '.wp-block-rm-step-box'
		checked = box.hasClass 'checked'
		box_id = box.attr 'id'

		api.post 'mark_step_box',
			box_id: box_id
			checked: !checked
		, (data) ->
			if data.updated
				box = $("[id=#{box_id}")
				if checked
					box.removeClass 'checked'
				else
					box.addClass 'checked'
	
	$(".hamburger").click ->
		$("nav[role=menu]").toggle()

	# document.addEventListener 'DOMContentLoaded', (event) ->
	# 	scrollpos = sessionStorage.getItem 'scrollpos'
	# 	if scrollpos
	# 		$(".main-inner").scrollTop scrollpos
	# 		sessionStorage.removeItem 'scrollpos'

	# window.addEventListener 'beforeunload', (e) ->
	# 	sessionStorage.setItem 'scrollpos', $(".main-inner").scrollTop()

) jQuery
